import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { LongButton } from '../LongButton';
import { AppHelper } from '../../utils/AppHelper';
import { DialogActions } from '../../actions/DialogActions';
import { ArticleActions } from '../../actions/ArticleActions';
import { UIHelper } from '../../utils/UIHelper';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { ImageSize, getImageSize } from '../../submodules/utils/Image';
import { GlobalHelper } from '../../utils/GlobalHelper';

export class ImportTab extends BaseHamburgerTab<{}> {
    protected previous: HamburgerTab = HamburgerTab.MENU;
    protected typicalFileInput: HTMLInputElement | null;
    protected imageFileInput: HTMLInputElement | null;

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                    <div className="long-button-group">
                        <LongButton
                            className="short-border"
                            onClick={AppHelper.importFromFilesystem}
                        >
                            {t('pCon Exchange Container')}
                        </LongButton>
                        <LongButton
                            className="short-border"
                            onClick={this.openImportImageDialog}
                        >
                            <input
                                type="file"
                                accept="image/png,image/jpeg,image/gif,image/bmp"
                                style={{ display: 'none' }}
                                onChange={this.loadImage}
                                ref={(node) => { this.imageFileInput = node; }}
                            />
                            {t('Image')}
                        </LongButton>
                        <LongButton
                            className="short-border with-icon icon-floorplan"
                            onClick={DialogActions.triggerFloorPlanUpload}
                        >
                            {t('Floor plan')}
                        </LongButton>
                    </div>
                </HamburgerContentWrapper>
            );
        }
        return (
            <div className={this.getCSSClass()}>
                <div className="hamburger-tab-content scrollbar-wcf">
                    {this.header()}
                    <div className="big-button-container" onClick={this.openImportTypicalDialog}>
                        <input
                            type="file"
                            accept=".pec"
                            onChange={this.importTypical}
                            className="open-input-element"
                            style={{ display: 'none' }}
                            ref={(node) => { this.typicalFileInput = node; }}
                        />
                        <div className="big-button pcon-format-button" />
                        <div className="big-button-text">{t('pCon Exchange Container')}</div>
                        <div className="big-button-text">{t('Insert drawings from the pCon.planner (in .pec format).')}</div>
                    </div>
                    {/* <div className="big-button-container" onClick={this.triggerClick(this.imageFileInput)}> */}
                    <div className="big-button-container" onClick={this.openImportImageDialog}>
                        <input
                            type="file"
                            accept="image/png,image/jpeg,image/gif,image/bmp"
                            style={{ display: 'none' }}
                            onChange={this.loadImage}
                            ref={(node) => { this.imageFileInput = node; }}
                        />
                        <div className="big-button image-button" />
                        <div className="big-button-text">{t('Image')}</div>
                        <div className="big-button-text">{t('Insert images for a vibrant background or as a wallpaper.')}</div>
                    </div>
                    <div className="big-button-container" onClick={DialogActions.triggerFloorPlanUpload}>
                        <div className="big-button floorplan-button" />
                        <div className="big-button-text">{t('Floor plan')}</div>
                        <div className="big-button-text">{t('Use an existing floor plan as template for your drawing.')}</div>
                    </div>
                </div>
            </div>
        );
    }

    protected getLabel(): string {
        return t('Import');
    }

    protected openImportTypicalDialog = (): void => {
        if (this.typicalFileInput) {
            this.typicalFileInput.click();
        }
    };

    protected openImportImageDialog = (): void => {
        if (this.imageFileInput) {
            this.imageFileInput.click();
        }
    };

    protected importTypical = (): void => {
        if (this.typicalFileInput) {
            ArticleActions.importTypical(this.typicalFileInput);
        }
    };

    protected loadImage = (event: React.FormEvent): void => {
        const input: HTMLInputElement = event.target as HTMLInputElement;
        if (!input.files || !input.files.length) {
            return;
        }

        const file: File = input.files[0];

        if (!/\.(png|jpe?g|gif|bmp)$/i.test(file.name)) {
            UIHelper.showMessage(t('This file can not be opened. You can open image files only.'));
            return;
        }

        ViewSettingsActions.withLock<void>(async (): Promise<void> => {
            try {
                const tResult: any = await new Promise<any>((resolve, reject) => {
                    const reader: FileReader = new FileReader();
                    reader.onerror = () => {
                        reject();
                    };
                    reader.onload = async () => {
                        resolve(reader.result);
                    };
                    reader.readAsDataURL(file);
                });
                const tImageSize: ImageSize | null = await getImageSize(tResult);
                if (tImageSize) {
                    await GlobalHelper.roomManager.insertBackgroundImage(tResult, tImageSize.width, tImageSize.height, 0, 0);
                    ViewSettingsActions.changeHamburger(null);
                }
            } catch (error) {
                UIHelper.showMessage(t('This file can not be opened.'));
            }
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/ImportTab.tsx